<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import Bin from '$icons/BinIcon.svelte';
  import EditLabel from '$lib/components/common/inputs/textInputs/editableLabels/EditLabel.svelte';
    import SimpleCaption from '../SimpleCaption.svelte';

  export let value = '';
  export let label = '';
  export let caption = '';
  export let maxLength = 250;
  export let placeholder = 'Enter here';
  export let danger: boolean = false;
  export let dangerMessage: string = '';
  export let autoHeight = false;
  export let textareaClass = '';
  export let removable = false;

  const dispatch = createEventDispatcher();

  let textareaElement: HTMLTextAreaElement;
  let textareaHeight = 70;

  $: {
    value, label;
    dispatch('change', { value, label });
  }

  function handleSubmit() {
    dispatch('submit', value);
  }
  $: dangerMessage = value?.length > maxLength ? `Characters cannot be more than ${maxLength}` : '';
</script>

<div class="flex flex-col items-start gap-2 w-full">
  <label class="text-garden-grey-600 font-medium text-sm flex flex-row justify-between w-full" for="">
    <span>
      <EditLabel
        bind:label
        on:labelChange={() => {
          dispatch('labelChange');
        }}
      />
    </span>

    <span
      class="text-garden-grey-400 text-xs flex gap-2 items-center"
      class:danger-wordcount={danger || dangerMessage}
    >
      {#if maxLength}
        {value?.length ?? 0}/{maxLength}
      {/if}

      {#if removable}
        <button on:click={() => dispatch('removeParagraph')}>
          <Bin class="stroke-accent-red-40" />
        </button>
      {/if}
    </span>
  </label>
  <div class="relative w-full">
    <textarea
      class="{textareaClass} input-style min-h-[70px] w-full border border-garden-grey-300 rounded-14 p-4 placeholder:text-garden-grey-400 text-garden-grey-600 outline-none ease-out duration-100"
      style="height: {autoHeight ? `${textareaHeight}px` : 'auto'};"
      class:input-danger={danger || dangerMessage}
      bind:value
      bind:this={textareaElement}
      on:keydown={event => {
        if (event.key === 'Enter') {
          handleSubmit();
        }
      }}
      on:input={() => (textareaHeight = value.length > 5 ? textareaElement.scrollHeight : 70)}
      {placeholder}
      maxlength={maxLength}
    />
    <div class="absolute right-1 bottom-3">
      <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 5L5 8M8 1L1 8" stroke="#212529" stroke-opacity="0.16" stroke-linecap="square" />
      </svg>
    </div>
  </div>
  <SimpleCaption {danger} {dangerMessage} {caption} variant={"styled"}/>
</div>

<style type="postcss">
  ::-webkit-resizer {
    display: none;
  }

  .input-style:focus {
    box-shadow:
      1px 1px 2px rgba(0, 0, 0, 0.07),
      0px 0px 0px 4px #ecefff;
  }
  .input-danger {
    @apply border-accent-red-40;
  }
  .input-danger:focus {
    box-shadow:
      1px 1px 2px rgba(0, 0, 0, 0.07),
      0px 0px 0px 4px #ffecec;
  }
  .danger-wordcount {
    @apply text-accent-red-40;
  }
</style>
